import { Button } from '@ascleo/ui/components/ui/button'
import { Eye } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useAccessibilitySession } from '../accessibility-session'

/**
 * Patient-facing readability/accessibility toggle.
 *
 * One-tap toggle in the self-service shell header. When active, the
 * `.frontdesk-readability-mode` class is applied to the shell root,
 * enabling larger text, higher contrast, and increased spacing.
 *
 * @since 1.0.0
 */
export function ReadabilityToggle() {
  const { t } = useTranslation()
  const { readabilityMode, toggleReadabilityMode } = useAccessibilitySession()

  return (
    <Button
      data-testid="frontdesk-readability-toggle"
      variant={readabilityMode ? 'default' : 'outline'}
      size="lg"
      onClick={toggleReadabilityMode}
      aria-pressed={readabilityMode}
      aria-label={t('self-service.readability.toggle-label')}
    >
      <Eye className="size-6" />
      <span className="ml-2 hidden @4xl/kiosk-header:inline">
        {readabilityMode
          ? t('self-service.readability.on')
          : t('self-service.readability.off')}
      </span>
    </Button>
  )
}
